import AllocatorProfileWizard from './AllocatorProfileWizard'

export default AllocatorProfileWizard
